import { Link, LinkSize, PrintIcon } from '@dreryk/react-components';

import { recommendationsTranslationKeys } from '../../../translations';

import { RecommendationsPrintActionEventInterceptor } from './interceptors/RecommendationsPrintActionEventInterceptor';

type RecommendationsPrintLinkProps = Readonly<{ visitId: number }>;

export const RecommendationsPrintLink = (props: RecommendationsPrintLinkProps): JSX.Element => {
   return (
      <RecommendationsPrintActionEventInterceptor visitId={props.visitId}>
         <Link
            icon={<PrintIcon />}
            testId={'print'}
            size={LinkSize.NORMAL}
            label={recommendationsTranslationKeys.actions.print}
         />
      </RecommendationsPrintActionEventInterceptor>
   );
};
